module.exports = __webpack_public_path__ + "7234d95fdfe999c0da00e3072d7baac3.pdf";